import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './list.module.scss';

export const EntitiesList = (props: { children: React.ReactNode }) => (
  <div className={styles.container} {...props} />
);

export const EntityValue: FC = (props) => (
  <div className={styles.value}>{props.children}</div>
);

export const EntitiesListItem = (props: {
  left: React.ReactNode;
  right: React.ReactNode;
}) => (
  <div className={styles.item}>
    <div className={styles.key}>{props.left}</div>
    <div className={styles.key}>
      {' '}
      <FormattedMessage id="components/entities-card/EntitiesList.tsx/1" />
    </div>
    <EntityValue>{props.right}</EntityValue>
  </div>
);

export const EntitiesListItemUnique = ({ text }: { text: string }) => (
  <div className={styles.item}>
    <div className={styles.key}>{text}</div>
  </div>
);
